(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-promise-slider"] && !Shopify.designMode) return;
  try {
    
  class PromiseSlider {
    constructor(section) {
      this.section = section;
      this.buttons = this.section.querySelectorAll('.promise-button');
      this.contentSlides = this.section.querySelectorAll('.content-slider__slide');
      this.videoSlides = this.section.querySelectorAll('.video-slider__slide');
      this.videos = this.section.querySelectorAll('.promise-video');
      
      this.enableAutoplay = this.section.dataset.enableAutoplay === 'true';
      this.autoplayDelay = parseInt(this.section.dataset.autoplayDelay, 10) * 1000;
      this.autoplayInterval = null;
      this.currentIndex = -1; // Start at -1 to ensure first slide transition works

      this.init();
    }

    init() {
      this.buttons.forEach(button => {
        button.addEventListener('click', () => {
          // When user clicks, stop the autoplay
          if (this.enableAutoplay) {
            clearInterval(this.autoplayInterval);
          }
          
          const index = parseInt(button.dataset.index, 10);
          this.goToSlide(index);

          // Restart autoplay after manual click
          if (this.enableAutoplay) {
            this.startAutoplay();
          }
        });
      });

      // Initialize with the first slide
      this.goToSlide(0);

      // Start autoplay if enabled
      if (this.enableAutoplay) {
        this.startAutoplay();
      }
    }

    startAutoplay() {
      clearInterval(this.autoplayInterval); // Clear any existing interval
      this.autoplayInterval = setInterval(() => {
        const nextIndex = (this.currentIndex + 1) % this.buttons.length;
        this.goToSlide(nextIndex);
      }, this.autoplayDelay);
    }

    goToSlide(index) {
      if (index === this.currentIndex) return;
      this.currentIndex = index;

      // Update buttons
      this.buttons.forEach((button, i) => {
        button.classList.toggle('is-active', i === index);
      });

      // Update content slides
      this.contentSlides.forEach((slide, i) => {
        slide.classList.toggle('is-active', i === index);
      });

      // Update video slides and handle video playback
      this.videoSlides.forEach((slide, i) => {
        slide.classList.toggle('is-active', i === index);
      });

      this.videos.forEach((video, i) => {
        if (i === index) {
          video.currentTime = 0;
          const playPromise = video.play();
          if (playPromise !== undefined) {
            playPromise.catch(error => {
              console.warn("Video autoplay prevented for slide:", index, error);
            });
          }
        } else {
          video.pause();
        }
      });
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    const sections = document.querySelectorAll('.promise-section-wrapper');
    sections.forEach(section => {
      new PromiseSlider(section);
    });
  });

  // Handle Shopify theme editor events
  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target.querySelector('.promise-section-wrapper');
    if (section) {
      new PromiseSlider(section);
    }
  });

  document.addEventListener('shopify:section:reorder', (event) => {
      const section = event.target.querySelector('.promise-section-wrapper');
      if (section) {
          new PromiseSlider(section);
      }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
